<template>
    <div id="missionDetails">
        <div id="headers">
            <img src="../assets/images/img_31.png" alt="" @click="returnPage">
            <div class="headerText">任务详情</div>
        </div>
        <!-- 头部 -->
        <div class="headerTop">
            <div class="timePanel">
                <div class="lefts">
                    <span class="tit">剩余时间</span>
                    <span class="num">{{surplusTimes}}</span>
                </div>
                <div class="rights">+{{detailData.price}}<span>元</span></div>
            </div>
        </div>
        <!-- 第一步 -->
        <div class="one">
            <!-- iskeywords：1表示无关键词，2表示有关键词 -->
            <div>
                <div v-if="detailData.iskeywords == 2" class="sign">第一步 搜索关键词</div>
                <div v-else class="sign">第一步 下载App</div>
            </div>
            <img :src="detailData.icon?detailData.icon:'../assets/images/img_77.png'" alt="" class="icons">
            <div v-if="detailData.iskeywords == 2" class="keyWord">关键词: {{detailData.keyword?detailData.keyword:'暂无'}}</div>

            <div v-if="detailData.iskeywords == 2" class="ranking">排名约<span>{{detailData.ranking}}</span>位 找到并下载</div>

            <div>
                <div v-if="detailData.iskeywords == 2" class="oneBtn" :data-clipboard-text="detailData.keyword" @click="toAppstore">前往App Store搜索下载</div>
                <div v-else class="oneBtn" :data-clipboard-text="detailData.keyword" @click="toAppstore">前往App Store下载</div>
            </div>
        </div>
        <!-- 第二步 -->
        <div class="two">
            <div class="twoSign">第二步  在本页面打开APP</div>
            <div class="twoKeyWord">试玩时必须允许【无线局域网与蜂窝移动网络】</div>
            <img src="../assets/images/img_19.png" alt="">
            <div @click="openApp" class="twoBtn">打开APP</div>
        </div>
        <!-- 第三步 -->
        <div class="boxPadding" v-if="!receiveReward">
            <div class="three">
                <div class="threeSign">第三步  领取奖励</div>
                <img src="../assets/images/img_01.png" alt="" class="threeIcons">
                <div class="threeKeyWord">试玩结束，领取奖励</div>
                <div class="threeErrorBtn">领取奖励</div>
            </div>
        </div>
        

        <!-- 第三步 -->
        <div class="boxPadding" v-else-if="receiveReward">
            <div class="three">
                <div class="threeSign">第三步  领取奖励</div>
                <img src="../assets/images/img_18.png" alt="" class="threeIcons">
                <div class="threeKeyWord">试玩结束，领取奖励</div>
                <div class="threeSuccessBtn" @click="reward">领取奖励</div>
            </div>
        </div>
        



        <popup :pops='pops' @fatherMethod='fatherMethod' @closed='closed' v-show="rewards"></popup>
        <popChoose @giveUp="giveUp" @notGiveUp="notGiveUp" v-show="choosePop"></popChoose>
    </div>
</template>

<script>
    // 引入弹窗
    import popup from '../components/Popup.vue'
    import popChoose from '../components/PopChoose.vue'

    import Clipboard from 'clipboard'

    // 引入助手接口
    import clientApi from '../assets/js/clientApi';

    // 引入vant
    import { Dialog } from 'vant';

    export default {
        components:{
            popup,
            popChoose,
        },
        data() {
            return {
                headersText:'',
                pops:{
                    icons:require('../assets/images/img_77.png'), //可选
                    iconWidth:60, // 可选（若有图片必填）
                    iconHeight:60, // 可选（若有图片必填）
                    tits1:'任务完成', // 可选
                    // tits2:'快去分享给小伙伴吧', // 可选
                    conts:'恭喜您成功领取奖励', // 可选
                    contsRed:'+1.5元',
                    btns:'继续做任务',
                    btnMarginTop:20,
                    closeImg:require('../assets/images/img_15.png')
                },
                rewards:false,
                choosePop:false,
                receiveReward:false, // 是否可领取奖励
                
                detailData:{}, // 详情数据
                surplusTimes:'', // 剩余时间
                timer:null, // 计时器

                activeAppTimer: null, // 开始打开app到可以领奖时的计时器
            }
        },
        mounted() {
            this.changeInit();
            this.addVisibles();
            // this.init();
        },
        destroyed() {
            this.removeVisible();
        },
        methods: {
            // 封装 visibilitychange事件
            hiddens(){
                if(!document.hidden){ 
                    clearInterval(this.timer);
                    this.surplusTimes = '';
                    this.changeInit();
                }
            },
            // 执行 visibilitychange事件
            addVisibles(){
                var hidden, state, visibilityChange; 
                if (typeof document.hidden !== "undefined") {
                    hidden = "hidden";
                    visibilityChange = "visibilitychange";
                    state = "visibilityState";
                } else if (typeof document.mozHidden !== "undefined") {
                    hidden = "mozHidden";
                    visibilityChange = "mozvisibilitychange";
                    state = "mozVisibilityState";
                } else if (typeof document.msHidden !== "undefined") {
                    hidden = "msHidden";
                    visibilityChange = "msvisibilitychange";
                    state = "msVisibilityState";
                } else if (typeof document.webkitHidden !== "undefined") {
                    hidden = "webkitHidden";
                    visibilityChange = "webkitvisibilitychange";
                    state = "webkitVisibilityState";
                }
                document.addEventListener(visibilityChange, this.hiddens, false);
            },
            // 移除 visibilitychange事件
            removeVisible(){
                var hidden, state, visibilityChange; 
                if (typeof document.hidden !== "undefined") {
                    hidden = "hidden";
                    visibilityChange = "visibilitychange";
                    state = "visibilityState";
                } else if (typeof document.mozHidden !== "undefined") {
                    hidden = "mozHidden";
                    visibilityChange = "mozvisibilitychange";
                    state = "mozVisibilityState";
                } else if (typeof document.msHidden !== "undefined") {
                    hidden = "msHidden";
                    visibilityChange = "msvisibilitychange";
                    state = "msVisibilityState";
                } else if (typeof document.webkitHidden !== "undefined") {
                    hidden = "webkitHidden";
                    visibilityChange = "webkitvisibilitychange";
                    state = "webkitVisibilityState";
                }
                document.removeEventListener(visibilityChange, this.hiddens, false);
            },
            // 封装执行函数
            changeInit(){
                if(this.$route.query.ids){
                    this.init();
                } else {
                    this.$toast('请返回快速任务页重新进入该页面')
                }
            },
            // 初始化请求
            init(){
                this.$loading(true);
                let datas = {
                    task_id:this.$route.query.ids
                }
                this.$http.POSTS('fast_task/detail',datas,(res)=>{
                    console.log(res.data)
                    this.detailData = res.data
                    this.countDownFun(res.data.task_endtime);

                    // 把价格传给领奖弹窗
                    this.pops.contsRed = this.detailData.price;
                    // 检测应用是否打开过
                    this.checkopen();

                    this.$loading(false);
                });
            },
            // 封装倒计时
            countDownFun(taskEndTime){
                if(taskEndTime <= 0){
                    this.surplusTimes = '00:00'
                    clearInterval(this.timer)
                } else {
                    this.timeFormat(taskEndTime);
                    this.timer = setInterval(()=>{
                        taskEndTime--;

                        if(taskEndTime <= 0){
                            this.surplusTimes = '00:00'
                            clearInterval(this.timer)
                        } else {
                            this.timeFormat(taskEndTime);
                        }
                        
                    },1000)
                }
            },
            timeFormat(taskEndTime){
                let endTimeMinute = Math.floor(taskEndTime/60%60);
                let endTimeSecond = Math.floor(taskEndTime%60);
                endTimeMinute = endTimeMinute>=10?endTimeMinute:'0'+endTimeMinute;
                endTimeSecond = endTimeSecond>=10?endTimeSecond:'0'+endTimeSecond;
                this.surplusTimes = endTimeMinute+':'+endTimeSecond;
            },
            // 返回
            returnPage:function(){
                // this.$router.go(-1);
                if(this.$route.query.ids){
                    this.choosePop = true;
                    // clearInterval(this.timer)
                } else {
                    this.$router.go(-1);
                    clearInterval(this.timer)
                }
            },

            // 点击跳转appstore
            toAppstore(){
                console.log(this.detailData.url)
            if(this.detailData.bundleid == "com.yy.onepiece" && this.detailData.iskeywords == 2){
                    var clipboard = new Clipboard('.oneBtn')
                    clipboard.on('success', e => {
                        this.$toast('复制关键词成功前往AppStore时禁止点击广告APP')
                        setTimeout(()=>{
                            window.location.href = 'https://itunes.apple.com/WebObjects/MZStore.woa/wa/search?mt=8&submit=edit&term='+''+'#software'
                        },1500)
                        // 释放内存
                        clipboard.destroy()
                    })
                }else if(this.detailData.iskeywords == 1){
                // 没有关键词
                window.location.href = this.detailData.url
            } else if(this.detailData.iskeywords == 2) {
                // 有关键词
                window.location.href = 'https://itunes.apple.com/WebObjects/MZStore.woa/wa/search?mt=8&submit=edit&term='+''+'#software'
                // var clipboard = new Clipboard('.oneBtn')
                // clipboard.on('success', e => {
                //     this.$toast('复制关键词成功')
                //     setTimeout(()=>{
                //         window.location.href = 'https://itunes.apple.com/WebObjects/MZStore.woa/wa/search?mt=8&submit=edit&term='+''+'#software'
                //     },1500)
                //     // 释放内存
                //     clipboard.destroy()
                // })
                // clipboard.on('error', e => {
                //     // 不支持复制
                //     this.$toast('该浏览器不支持自动复制')
                //     // 释放内存
                //     clipboard.destroy()
                // })
            }

            },
            // 打开应用
            openApp() {
                // 可以领奖后不在打开应用 （钱大师这边暂时不要这个判断）
                // if(this.receiveReward === true) {
                //     return;
                // }
                if(this.detailData.task_assistance.is_ios11 === true) {
                    this.checkInstallForiOS11();
                }else {
                    this.checkInstallForiOS10();
                }
            },
            // iOS 10及以下检测是否安装应用并打开
            checkInstallForiOS10() {
                let params = '?bundleid=' + encodeURIComponent(this.detailData.boundid);
                clientApi.isAppExistForiOS10(params).then((response)=> {
                    if (response.status == 1) {
                        //1直接打开应用，2推送本地消息
                        clientApi.ios11openurl(data).then((response)=> {
                            let pushData={title:"温馨提示：您的任务正在进行中，打开时请允许App网络访问哟"};
                            clientApi.localpush(pushData);

                            //开始任务
                            this.clientStartTask();
                        }).catch( (err)=> {
                            Dialog.alert({message: '网络错误'});
                        });
                    }else {
                        Dialog.alert({message: 'APP未安装，快去APP store下载吧'});
                    }
                }).catch( (err)=>{
                    Dialog.alert({message: '网络错误'});
                });
            },
            // iOS 11及以上检测是否安装应用并打开
            checkInstallForiOS11() {
                let data={bundleid: encodeURIComponent(this.detailData.boundid)};
                clientApi.ios11openurl(data).then((response)=> {
                    if(response.data==1){
                        let pushData={title:"温馨提示：您的任务正在进行中，打开时请允许App网络访问哟"};
                        clientApi.localpush(pushData);

                        //开始任务
                        this.clientStartTask();
                    }else {
                        Dialog.alert({message: 'APP未安装，快去APP store下载吧'});
                    }
                }).catch( (err)=> {
                    Dialog.alert({message: '网络错误'});
                });
            },
            // 检测是否安装应用后再开始客户端任务
            clientStartTask() {
                let starttaskData={
                    bundleid: this.detailData.boundid,
                    task_id: this.detailData.id,
                    idfa: this.detailData.task_assistance.idfa,
                    taskname: "是否打开任务『"+ this.detailData.name + "』"
                }
                clientApi.v2cattrystarttask(starttaskData).then((response)=>{
                    if(response.status == "1"){
                        this.checkopen();
                    }else{
                        if(response.data == -51){
                            Dialog.alert({message: '广告标识符修改过，请放弃任务，重新登录'});
                        }else if(response.data == -50){
                            Dialog.alert({message: '数据错误'});
                        }else if(response.data == -100){
                            Dialog.alert({message: '网络超时'});
                        }else{
                            Dialog.alert({message: '数据错误'+ response.data});
                        }
                    }
                }).catch ((err)=>{
                    console.log(err)
                });
            },
            // 检测原来是否打开过应用
            checkopen() {
                let datas = {
                    task_id: this.detailData.id,
                    idfa: this.detailData.task_assistance.idfa,
                    boundid: this.detailData.boundid
                }
                this.$http.POSTS('fast_task/isOpenApp',datas,(res)=>{
                    this.$loading(false);
                    console.log(res.data)
                    if(res.data.is_open == 1) {
                        // 如果本身打开过应用直接开始计时
                        this.activeAppTimeCount();
                    }else {
                        return false;
                    }
                });
            },
            // 领取奖励
            reward:function(){
                if(this.receiveReward === false) {
                    return;
                }
                this.$loading(true);
                let params = '?opt=' + this.detailData.task_assistance.active_app_param;
                clientApi.activeAppAward(params).then((response) => {
                    this.$loading(false);
                    console.log(response);  
                    if (response.status == 1 || response.status == -11 ||response.status == 2) {
                        if(response.data.status == 2){
                            Dialog.alert({title:'温馨提示', message: "你为非首次安装，不会获得奖励"}).then((response)=>{
                                this.$router.replace('/fastTasks');
                            })
                        }else{
                            this.rewards=true  // 展示领奖成功弹窗
                        }
                    }else{
                        if(response.data == -100){
                            Dialog.alert({title:'温馨提示', message: "网络不好，请检查网络"});
                            return;
                        }
                        if(response.data == -51){
                            Dialog.alert({title:'温馨提示', message: "广告标识符修改过，请放弃任务并关闭懒猫重新打开进行任务！"});
                            return;
                        }
                        if(response.data == -55){
                            if(response.error.version == 9 || response.error.version == 7){
                                Dialog.alert({title:'温馨提示', message: "试玩时间未到,请再去试玩"});
                                return;
                            }else{
                                Dialog.alert({title:'温馨提示', message: "试玩时间未到,请再去试玩"});
                                setTimeout(function () {
                                    document.location.href = "lazycat://";
                                },100);
                                return;
                            }
                        }
                        var result = JSON.parse(response.data);
                        if(result.status == 0){
                            if(result.data==-2){
                                // 放弃任务
                                let datas = {
                                    task_id:this.$route.query.ids
                                }
                                this.$http.POSTS('fast_task/untask',datas,(res)=>{
                                    this.$router.go('/fastTasks');
                                });
                            }else {
                                Dialog.alert({title:'温馨提示', message: result.info});
                            }
                        }else {
                            Dialog.alert({title:'温馨提示', message: "试玩时间未到,请再去试玩"});
                        }
                    }
                }).catch((err) => {
                    this.$loading(false);
                    Dialog.alert({title: "温馨提示", message: "领奖过程网络错误，请稍后重试！"});
                });
            },
            // 到可以领奖的倒计时
            activeAppTimeCount() {
                if(this.activeAppTimer) {
                    return;
                }
                let params = "?bundleid=" + this.detailData.boundid;
                this.activeAppTimer = setInterval(() => {
                    clientApi.checkOpenAppTime(params).then((response) => {
                        if (response.status != 1) {
                            return false;
                        }
                        let time = parseInt(response.data) + 180;
                        let nowDate = new Date();
                        let nowTime = nowDate.getTime() / 1000;
                        let openAppTime = parseInt(time - nowTime);
                        if(openAppTime < 0){
                            clearInterval(this.activeAppTimer);
                            this.receiveReward = true;
                        }
                    }).catch(function (err) {
                        console.log(err);
                    });
                }, 1500)
            },
            fatherMethod:function(){
                this.rewards = false;
                this.$router.replace('/fastTasks');
            },
            closed:function(){
                this.rewards = false;
                this.$router.replace('/fastTasks');
            },

            // 放弃任务
            giveUp:function(){
                let datas = {
                    task_id:this.$route.query.ids
                }
                this.$http.POSTS('fast_task/untask',datas,(res)=>{
                    this.choosePop = false
                    this.$router.go(-1);
                });
                
            },
            // 不放弃任务
            notGiveUp:function(){
                this.choosePop = false
            }
        },

        beforeRouteEnter(to, from, next) {
            if(from.name=='fastTasks'){
                to.meta.keepAlive = false;
            } else {
                to.meta.keepAlive = true;
            }
            next();
        },
    }
</script>

<style lang="less" scoped>
    #missionDetails{
        // 导航栏
        #headers{
            width: 375px;
            height: 45px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            img{
                width: 11px;
                height: 18px;
                position: absolute;
                left: 15px;
                padding: 0 3px;
            }
            .headerText{
                font-size: 15px;
                color: #FFFFFF;
            }
        }
        // 头部
        .headerTop{
            width:375px;
            height:35px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            .timePanel{
                width:345px;
                height:60px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,1);
                position: relative;
                top: 8px;
                margin: 0 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .lefts{
                    margin-left: 30px;
                    .tit{
                        font-size:15px;
                        color:rgba(51,51,51,1);
                        line-height:15px;
                    }
                    .num{
                        margin-left: 10px;
                        font-size:20px;
                        color:rgba(51,51,51,1);
                        line-height:20px;
                        font-weight: bold;
                        font-family: Arial, Helvetica, sans-serif;
                    }
                }
                .rights{
                    margin-right: 22px;
                    font-size:35px;
                    font-family: "Qds";
                    color:rgba(230,9,26,1);
                    line-height:42px;
                    font-weight: bold;
                    position: relative;
                    top: 4px;
                    span{
                        font-size: 14px;
                    }
                }
            }
        }
        // 第一步
        .one{
            margin: 48px 15px 0;
            width:345px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            border-radius:5px;
            border:1px solid rgba(222,222,222,1);
            display: flex;
            flex-direction: column;
            align-items: center;
            .sign{
                width:143px;
                height:32px;
                background:rgba(249,249,249,1);
                border-radius:0px 0px 8px 8px;
                border:1px solid rgba(222,222,222,1);
                font-size:13px;
                color:rgba(102,102,102,1);
                text-align: center;
                line-height:32px;
                border-top: none;
                font-weight: bold;
            }
            .icons{
                width: 60px;
                height: 60px;
                margin: 20px 0;
                border-radius:12px;
            }
            .keyWord{
                font-size:20px;
                color:rgba(21,21,21,1);
                line-height:20px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            .ranking{
                font-size:13px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:17px;
                span{
                    font-size: 20px;
                    color: #E50113;
                }
            }
            .oneBtn{
                width:250px;
                height:45px;
                background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
                box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
                border-radius:25px;
                font-size:15px;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:45px;
                text-align: center;
                margin: 20px 0;
            }
        }
        // 第二步
        .two{
            width:345px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            border-radius:5px;
            border:1px solid rgba(222,222,222,1);
            margin: 15px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .twoSign{
                width:186px;
                height:32px;
                background:rgba(249,249,249,1);
                border-radius:0px 0px 8px 8px;
                border:1px solid rgba(222,222,222,1);
                font-size:13px;
                color:rgba(102,102,102,1);
                line-height:32px;
                text-align: center;
                border-top: none;
                font-weight: bold;
            }
            .twoKeyWord{
                width:308px;
                height:56px;
                font-size:17px;
                font-weight:600;
                color:rgba(21,21,21,1);
                line-height:28px;
                margin: 20px 0 15px;
            }
            img{
                width:300px;
                height:31px;
                background:rgba(255,255,255,1);
                box-shadow:0px 6px 11px 0px rgba(0,0,0,0.05);
                border:1px solid rgba(222,222,222,1);
            }
            .twoBtn{
                width:250px;
                height:45px;
                background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
                box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
                border-radius:25px;
                font-size:15px;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:45px;
                text-align: center;
                margin: 30px 0 20px;
            }
        }
        // 第三步
        .boxPadding{
            padding: 0 15px 15px;
            .three{
                width:345px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,1);
                display: flex;
                flex-direction: column;
                align-items: center;
                .threeSign{
                    width:134px;
                    height:32px;
                    background:rgba(249,249,249,1);
                    border-radius:0px 0px 8px 8px;
                    border:1px solid rgba(222,222,222,1);
                    font-weight: bold;
                    font-size:13px;
                    color:rgba(102,102,102,1);
                    line-height:32px;
                    text-align: center;
                }
                .threeIcons{
                    width: 50px;
                    height: 48px;
                    margin: 36px 0 8px;
                }
                .threeKeyWord{
                    font-size:17px;
                    font-weight:600;
                    color:rgba(21,21,21,1);
                    line-height:28px;
                }
                .threeErrorBtn{
                    width:250px;
                    height:45px;
                    background:linear-gradient(26deg,rgba(98,107,106,1) 0%,rgba(215,222,229,1) 100%);
                    box-shadow:0px 5px 10px 0px rgba(0,0,0,0.15);
                    border-radius:25px;
                    font-size:15px;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    line-height:45px;
                    text-align: center;
                    margin: 20px 0;
                }
                .threeSuccessBtn{
                    width:250px;
                    height:45px;
                    background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
                    box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
                    border-radius:25px;
                    font-size:15px;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    line-height:45px;
                    text-align: center;
                    margin: 20px 0;
                }
            }
        }
    }
</style>